module.exports = __webpack_public_path__ + "img/36.2aee432c.jpg";